module.exports = __webpack_public_path__ + "media/markers/ramp_brn-8047560b.svg";